(function(){
'use strict';
function initStickyHeader(){
  var h=document.querySelector('.site-header');
  if(!h)return;
  window.addEventListener('scroll',function(){h.classList.toggle('scrolled',window.scrollY>40);},{passive:true});
}
function initMobileNav(){
  var t=document.querySelector('.mobile-toggle'),m=document.querySelector('.mobile-menu'),c=document.querySelector('.mobile-menu-close');
  if(!t||!m)return;
  t.addEventListener('click',function(){m.classList.add('active');document.body.style.overflow='hidden';});
  if(c)c.addEventListener('click',function(){m.classList.remove('active');document.body.style.overflow='';});
  m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('active');document.body.style.overflow='';});});
}
function initSearch(){
  var btn=document.querySelector('.search-toggle'),overlay=document.querySelector('.search-overlay');
  if(!btn||!overlay)return;
  var input=overlay.querySelector('.search-main-input');
  btn.addEventListener('click',function(e){e.preventDefault();overlay.classList.add('active');if(input)input.focus();});
  overlay.addEventListener('click',function(e){if(e.target===overlay){overlay.classList.remove('active');}});
  var closeBtn=overlay.querySelector('.search-close-btn');
  if(closeBtn)closeBtn.addEventListener('click',function(){overlay.classList.remove('active');});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')overlay.classList.remove('active');});
  if(input){
    var resultsEl=document.getElementById('searchResults');
    var debounce;
    input.addEventListener('input',function(){
      clearTimeout(debounce);
      var q=input.value.trim();
      if(q.length<2){if(resultsEl)resultsEl.innerHTML='';return;}
      debounce=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
        .then(function(r){return r.json();})
        .then(function(data){
          if(!resultsEl)return;
          var products=data.resources&&data.resources.results&&data.resources.results.products||[];
          if(!products.length){resultsEl.innerHTML='<p style="padding:12px;color:#999;font-size:14px;">Ingen resultater fundet</p>';return;}
          resultsEl.innerHTML=products.map(function(p){
            var img=p.image?('<img src="'+p.image+'" width="48" height="48" style="object-fit:cover;border-radius:6px;">'):'';
            return '<a href="'+p.url+'" style="display:flex;align-items:center;gap:12px;padding:10px 12px;border-radius:6px;transition:background 0.15s;">'+img+'<div><div style="font-size:14px;font-weight:500;">'+p.title+'</div><div style="font-size:13px;color:#999;">'+p.price+'</div></div></a>';
          }).join('');
        }).catch(function(){});
      },300);
    });
  }
}
function initPopup(){
  var popup=document.getElementById('newsletterPopup');
  if(!popup||sessionStorage.getItem('nc_popup_closed'))return;
  setTimeout(function(){popup.classList.add('active');},8000);
  var close=popup.querySelector('.popup-close');
  if(close)close.addEventListener('click',function(){popup.classList.remove('active');sessionStorage.setItem('nc_popup_closed','1');});
  popup.addEventListener('click',function(e){if(e.target===popup){popup.classList.remove('active');sessionStorage.setItem('nc_popup_closed','1');}});
}
function initProductGallery(){
  var gallery=document.getElementById('productGallery'),lightbox=document.getElementById('productLightbox');
  if(!gallery||!lightbox)return;
  var lbImg=lightbox.querySelector('img'),lbCounter=lightbox.querySelector('.lightbox-counter');
  var images=[];
  gallery.querySelectorAll('.product-gallery-slide img').forEach(function(img){images.push(img.src.replace(/width=\d+/,'width=1800'));});
  var idx=0;
  function show(i){idx=(i+images.length)%images.length;lbImg.src=images[idx];if(lbCounter)lbCounter.textContent=(idx+1)+' / '+images.length;}
  function open(i){show(i);lightbox.classList.add('active');document.body.style.overflow='hidden';}
  function close(){lightbox.classList.remove('active');document.body.style.overflow='';}
  gallery.querySelectorAll('.product-gallery-slide').forEach(function(s,i){s.addEventListener('click',function(){open(i);});});
  lightbox.querySelector('.lightbox-close').addEventListener('click',close);
  lightbox.querySelector('.lightbox-prev').addEventListener('click',function(e){e.stopPropagation();show(idx-1);});
  lightbox.querySelector('.lightbox-next').addEventListener('click',function(e){e.stopPropagation();show(idx+1);});
  lightbox.addEventListener('click',function(e){if(e.target===lightbox)close();});
  document.addEventListener('keydown',function(e){if(!lightbox.classList.contains('active'))return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')show(idx-1);if(e.key==='ArrowRight')show(idx+1);});
  var dots=document.querySelectorAll('.gallery-dot');
  if(dots.length){
    gallery.addEventListener('scroll',function(){var i=Math.round(gallery.scrollLeft/gallery.offsetWidth);dots.forEach(function(d,j){d.classList.toggle('active',j===i);});},{passive:true});
    dots.forEach(function(d){d.addEventListener('click',function(){gallery.scrollTo({left:parseInt(d.dataset.index)*gallery.offsetWidth,behavior:'smooth'});});});
  }
}
function initQuantity(){
  document.querySelectorAll('.qty-wrap').forEach(function(w){
    var input=w.querySelector('.qty-input');
    w.querySelectorAll('.qty-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var v=parseInt(input.value)||1;
        if(this.textContent.trim()==='+')input.value=v+1;
        else input.value=Math.max(1,v-1);
      });
    });
  });
}
function initWishlistButtons(){
  document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn){
    var id=btn.dataset.wishlistBtn;
    if(window.NC&&NC.isWishlisted(id))btn.classList.add('active');
    btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(window.NC)NC.toggleWishlist(id,btn.dataset.wishlistHandle||'');});
  });
}
document.addEventListener('DOMContentLoaded',function(){
  initStickyHeader();initMobileNav();initSearch();initPopup();
  initProductGallery();initQuantity();initWishlistButtons();
});
})();
